<template>
  <div class="d-flex flex-column text-center pa-4">
    <m-language v-model="languages" :label="$t('profile.personal.languages')" />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { IUser } from '@mentessa/types';
import { MLanguage } from '@/components/Inputs';

export default Vue.extend({
  name: 'm-onboarding-languages-form',
  components: {
    MLanguage,
  },
  props: {
    value: Object as PropType<IUser>,
  },
  computed: {
    languages: {
      get() {
        return this.value?.attributes.languages ?? [];
      },
      set(value: Array<string>) {
        this.$emit('input', {
          ...this.value,
          attributes: {
            ...this.value?.attributes,
            languages: value,
          },
        });
      },
    },
  },
});
</script>
